import { c as _c } from "react/compiler-runtime";
import { Fragment, useSyncExternalStore } from "react";
export type Language = "de" | "en";
const LANGUAGES: {
  label: string;
  language: Language;
}[] = [{
  label: "DE",
  language: "de"
}, {
  label: "EN",
  language: "en"
}];
const linkClass = (active: boolean) => `text-body-2 px-2xs py-2xs rounded-s transition-colors no-underline ${active ? "text-neutral-675 font-semibold hover:bg-neutral-12" : "text-neutral-425 font-book hover:text-primary-800 hover:bg-neutral-12"}`;
const subscribeToLocation = (onLocationChange: () => void) => {
  window.addEventListener("hashchange", onLocationChange);
  window.addEventListener("popstate", onLocationChange);
  return () => {
    window.removeEventListener("hashchange", onLocationChange);
    window.removeEventListener("popstate", onLocationChange);
  };
};
const getSearch = () => window.location.search;
const getHash = () => window.location.hash;
const getServerLocationPart = () => "";
const LanguageLinks = t0 => {
  const $ = _c(11);
  const {
    language,
    alternateLanguageHref
  } = t0;
  const search = useSyncExternalStore(subscribeToLocation, getSearch, getServerLocationPart);
  const hash = useSyncExternalStore(subscribeToLocation, getHash, getServerLocationPart);
  let t1;
  if ($[0] !== alternateLanguageHref || $[1] !== search) {
    t1 = /[?#]/.test(alternateLanguageHref ?? "") ? "" : search;
    $[0] = alternateLanguageHref;
    $[1] = search;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const query = t1;
  let t2;
  if ($[3] !== alternateLanguageHref || $[4] !== hash) {
    t2 = alternateLanguageHref?.includes("#") ? "" : hash;
    $[3] = alternateLanguageHref;
    $[4] = hash;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const fragment = t2;
  const href = alternateLanguageHref ? `${alternateLanguageHref}${query}${fragment}` : null;
  let t3;
  if ($[6] !== href || $[7] !== language) {
    t3 = LANGUAGES.map((entry, index) => <Fragment key={entry.label}>{index > 0 && <span className="w-[1px] h-[14px] bg-neutral-50" aria-hidden="true" />}{entry.language === language ? <span className={linkClass(true)} aria-current="true">{entry.label}</span> : href ? <a className={linkClass(false)} href={href}>{entry.label}</a> : <span className="text-body-2 px-2xs py-2xs rounded-s text-neutral-425 font-book cursor-not-allowed" aria-disabled="true" aria-label={language === "de" ? "Englische \xDCbersetzung nicht verf\xFCgbar" : "German translation unavailable"}>{entry.label}</span>}</Fragment>);
    $[6] = href;
    $[7] = language;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t3) {
    t4 = <div className="flex items-center ml-3xs">{t3}</div>;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};
export default LanguageLinks;